function filterVoicemailPrompts(rows, query) {
  const list = Array.isArray(rows) ? rows : [];
  const q = String(query || "").trim().toLowerCase();
  if (!q) return list.slice();
  return list.filter((row) => {
    const hay = [
      row && row.purpose,
      row && row.recordedBy,
      row && row.description,
      row && row.length,
    ]
      .map((part) => String(part || "").toLowerCase())
      .join(" ");
    return hay.includes(q);
  });
}

module.exports = {
  filterVoicemailPrompts,
};
